import React from 'react';
import { Box, Typography, Container, List, ListItem, ListItemText } from '@mui/material';

function PrivacyPolicy() {
    return (
        <Container maxWidth="md">
            <Box sx={{ padding: '20px' }}>
                <Typography variant="h5" gutterBottom>
                    FM Digital Official Privacy Policy
                </Typography>
                <Typography variant="subtitle1" gutterBottom>
                    Last Updated: (August 2024)
                </Typography>
                <Typography variant="body1" gutterBottom>
                    At FM Digital Official, we are committed to protecting the privacy and security of our users' personal information. This Privacy Policy explains how we collect, use, disclose, and protect your information when you interact with our website and services. By using our services, you agree to the practices outlined in this policy.
                </Typography>
                <Typography variant="h6" gutterBottom>
                    1. Information We Collect
                </Typography>
                <Typography variant="body1" gutterBottom>
                    We may collect the following types of information:
                </Typography>
                <List>
                    <ListItem>
                        <ListItemText primary="1.1 Personal Information:" secondary="When you register, use our services, or communicate with us, we may collect personal information such as Name, Email Address, Contact Number, Mailing Address, Payment Information." />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary="1.2 Usage Information:" secondary="We collect data related to how you interact with our services, including IP Address, Browser type, Operating system, Referring URLs, Pages visited, Time spent on each page." />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary="1.3 Cookies and Tracking Technologies:" secondary="We use cookies and similar tracking technologies to improve your experience, save preferences, and gather usage data. You can disable cookies in your browser settings, but this may limit certain features." />
                    </ListItem>
                </List>

                <Typography variant="h6" gutterBottom>
                    2. How We Use Your Information
                </Typography>
                <Typography variant="body1" gutterBottom>
                    We use your information to:
                </Typography>
                <List>
                    <ListItem>
                        <ListItemText primary="Provide and improve our services." />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary="Process payments and manage billing." />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary="Communicate updates, promotions, and new services." />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary="Respond to inquiries and provide support." />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary="Personalize your experience." />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary="Comply with legal and regulatory obligations." />
                    </ListItem>
                </List>

                <Typography variant="h6" gutterBottom>
                    3. How We Share Your Information
                </Typography>
                <Typography variant="body1" gutterBottom>
                    We do not sell or rent your personal information to third parties. However, we may share information in the following cases:
                </Typography>
                <List>
                    <ListItem>
                        <ListItemText primary="Service Providers: We may share your data with third-party vendors who assist us with services like payment processing, hosting, and customer support." />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary="Legal Obligations: We may disclose your information if required by law or in response to legal processes." />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary="Business Transfers: In the case of a merger, acquisition, or sale, your information may be transferred to the new entity." />
                    </ListItem>
                </List>

                <Typography variant="h6" gutterBottom>
                    4. Data Security
                </Typography>
                <Typography variant="body1" gutterBottom>
                    We use industry-standard security practices to protect your personal information. However, no method of transmission over the Internet is entirely secure, and we cannot guarantee absolute security.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    5. Your Rights
                </Typography>
                <Typography variant="body1" gutterBottom>
                    You have the following rights regarding your personal data:
                </Typography>
                <List>
                    <ListItem>
                        <ListItemText primary="Access and Correction: You may request access to or corrections of your personal information." />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary="Data Portability: You can request a copy of your data in a common format." />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary="Deletion: You can request the deletion of your personal data unless we are required by law to retain it." />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary="Opt-out of Marketing: You can opt out of receiving marketing communications by following the unsubscribe link in emails." />
                    </ListItem>
                </List>

                <Typography variant="h6" gutterBottom>
                    6. Data Retention
                </Typography>
                <Typography variant="body1" gutterBottom>
                    We retain personal data as long as necessary for the purposes outlined in this policy or as required by law.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    7. Children’s Privacy
                </Typography>
                <Typography variant="body1" gutterBottom>
                    FM Digital Official does not knowingly collect information from individuals under 18 years of age. If we discover that a minor has provided us with personal data, we will take steps to delete that information.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    8. Third-Party Links
                </Typography>
                <Typography variant="body1" gutterBottom>
                    Our services may contain links to third-party websites. We are not responsible for the privacy practices of these websites, and we encourage you to read their privacy policies.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    9. Changes to the Privacy Policy
                </Typography>
                <Typography variant="body1" gutterBottom>
                    FM Digital Official reserves the right to update this Privacy Policy. We will notify you of any significant changes via email or by posting the updated policy on our website. Continued use of our services after the updates indicates acceptance of the new terms.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    10. Contact Us
                </Typography>
                <Typography variant="body1" gutterBottom>
                    For questions or concerns regarding this Privacy Policy, please contact us at:
                </Typography>
                <Typography variant="body1">
                    FM Digital Official <br />
                    India, Asia
                </Typography>
            </Box>
        </Container>
    );
}

export default PrivacyPolicy;
